//#region 宣言
/// <reference path="../../resources/typings/index.d.ts" />
//#endregion 宣言


export class Main {

    /*
     * materialize:セレクトボックス
     */
    public static ApplyMaterializeSelectBox() {

        var elems = document.querySelectorAll('select');
        var instances = M.FormSelect.init(elems, {});

    }

    /*
     * materialize:dropdown
     */
    public static ApplyMaterializeDropDown() {

        //materialize:dropdown
        let option = {
            hover: false,
            constrainwidth: false,
        };

        $('.dropdown-trigger').dropdown(option);
    }

    /**
     * materialize:collapsible
     */
    public static ApplyMaterializeCollapsible() {

        var elems = $('.collapsible');
        let options = {
            accordion: false,
            onOpen: (el) => {
                $(el).find('.collapsible-header').addClass('active');
            },
            onClose: (el) => {
                $(el).find('.collapsible-header').removeClass('active');
            }
        };

        var instances = M.Collapsible.init(elems, options);
    }

    /**
     * スマフォ用サイドバー
     */
    public static ApplyMaterializeSideNav() {
        let elems = document.querySelectorAll('.side-nav');
        let options = {};
        let instances = M.Sidenav.init(elems, options);
    }
    
    
    /**
    * Get the URL parameter value
    *
    * @param  name {string} パラメータのキー文字列
    * @return  url {url} 対象のURL文字列（任意）
    */
    public static GetParam(name, url?) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, " "));
    }
    
}


//#region イベント





$(function () {

    Main.ApplyMaterializeSelectBox();
    Main.ApplyMaterializeDropDown();
    Main.ApplyMaterializeCollapsible();
    Main.ApplyMaterializeSideNav();


    // 言語切替
    $(document).on('click', '.changeLang', function () {
        let locale = $(this).data('lang');
        $.ajax({
            url: '/me/locale',
            type: 'GET',
            dataType: 'json',
            data: {
                locale: locale,
            }
        }).done(function (response) {

            // 言語切替が成功していたらリロード
            if (response.result) {
                location.reload();
            }
        });
    });

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

});


//#endregion イベント



// WEBPACK FOOTER //
// ./public/js/index.ts